import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import {
    InMemoryScrollingOptions,
    provideRouter,
    withEnabledBlockingInitialNavigation,
    withInMemoryScrolling,
    withRouterConfig,
} from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions, withIncrementalHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { environment } from '../environments/environment';
import { provideEnvironment } from '@seven1/angular-storyblok/environment';
import { provideSeo } from '@seven1/angular/seo';
import { provideStoryblokImages } from '@seven1/angular-storyblok/image';
import { provideStoryblok } from '@seven1/angular-storyblok/api';
import { provideKameleoon } from '@seven1/angular/kameleoon';
import { provideUsercentrics } from '@seven1/angular/usercentrics';
import { provideGtm } from '@seven1/angular/gtm';
import { provideTariff } from './tariff';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideGtm(environment.google_tag_manager),
        provideAnimationsAsync(),
        provideRouter(
            routes,
            withInMemoryScrolling(scrollConfig),
            withRouterConfig({}),
            withEnabledBlockingInitialNavigation()
        ),
        provideClientHydration(
            withHttpTransferCacheOptions({
                includePostRequests: true,
            }),
            withEventReplay(),
            withIncrementalHydration()
        ),
        provideHttpClient(
            withFetch(),
        ),
        provideZoneChangeDetection({
            eventCoalescing: true,
            runCoalescing: true,
        }),
        {
            provide: LOCALE_ID,
            useValue: 'de-DE',
        },
        provideEnvironment(environment),
        provideUsercentrics(environment.usercentrics),
        provideKameleoon(environment.kameleoon),
        provideStoryblok(environment.cms),
        provideStoryblokImages(),
        provideSeo('SaferYou'),
        provideTariff(),
    ],
};
